/**
 * The number on the app's icon: how many games are waiting on you. Browsers without app badges skip it, and one may
 * refuse (NotAllowedError) when the app isn't installed or allowed; that refusal is expected and ignored.
 */
export function showBadge(count) {
  if (!('setAppBadge' in navigator)) {
    return Promise.resolve();
  }

  const shown = count > 0 ? navigator.setAppBadge(count) : navigator.clearAppBadge();

  return shown.catch((error) => {
    if (error.name !== 'NotAllowedError') {
      throw error;
    }
  });
}
